import { Project, SoilingRiskAssessment } from '../types';

export const refProjects: Project[] = [
  {
    id: '0',
    name: 'Nova Aurora',
    description: 'Coast (high humidity)',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -48.9752,
      latitude: -28.4473,
    },
  },
  {
    id: '1',
    name: 'Coya PV',
    description: 'Dry, dessertic',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -69.5931,
      latitude: -22.369,
    },
  },
  {
    id: '2',
    name: 'El Aguila Solar',
    description: 'Dry, dessertic, morning dew',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -69.8861,
      latitude: -18.4453,
    },
  },
  {
    id: '3',
    name: 'Alconchel',
    description: 'Seasonal (dry season, rany season)',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -7.06018,
      latitude: 38.5203,
    },
  },
  {
    id: '4',
    name: 'Osuna',
    description: 'Seasonal (dry season, rany season)',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -5.06626,
      latitude: 37.2065,
    },
  },
  {
    id: '5',
    name: 'Les Iscles',
    description: 'Frequent rain throughout the year',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: 4.855697,
      latitude: 43.882,
    },
  },
  {
    id: '6',
    name: 'Bhadla',
    description: 'Cleaning robots installed',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: 71.96369,
      latitude: 27.47811,
    },
  },
  {
    id: '7',
    name: 'Sol De Insurgentes',
    description: 'High humidity, rain once per year',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -111.76,
      latitude: 25.2,
    },
  },
  {
    id: '8',
    name: 'Trompezon',
    description: 'Seasonal, they use cleaning tractors',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -102.177,
      latitude: 21.728,
    },
  },
  {
    id: '9',
    name: 'Scaling Solar-Kahone',
    description: 'Dry landscape, close to coast',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -16.0249,
      latitude: 14.17044,
    },
  },
  {
    id: '10',
    name: 'Holman',
    description: 'Dry landscape, but low soiling risk',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: -103.475,
      latitude: 30.455,
    },
  },
  {
    id: '11',
    name: 'Aurora-Rietvlie',
    description: 'Dry landscape, close to coast',
    progress: 50,
    soiling_risk_assessment: SoilingRiskAssessment.HIGH,
    monthly_soiling_rate: 2.5,
    cleaning_solution: 'Boson',
    yearly_cleaning_frequency: 4,
    location: {
      longitude: 18.50386,
      latitude: -32.644,
    },
  },
  // {
  //   id: '0',
  //   name: 'ENGIE Laborelec PV',
  //   description: 'desc',
  //   progress: 50,
  //   soiling_risk_assessment: SoilingRiskAssessment.HIGH,
  //   monthly_soiling_rate: 2.5,
  //   cleaning_solution: 'Boson',
  //   yearly_cleaning_frequency: 4,
  //   location: {
  //     longitude: 4.3448056,
  //     latitude: 50.7593614,
  //   }
  // },
  // {
  //   id: '1',
  //   name: 'DON',
  //   description: 'desc',
  //   progress: 50,
  //   soiling_risk_assessment: SoilingRiskAssessment.HIGH,
  //   monthly_soiling_rate: 2.5,
  //   cleaning_solution: 'Boson',
  //   yearly_cleaning_frequency: 4,
  //   location: {
  //     latitude: 30.153889,
  //     longitude: -111.091111
  //   }
  // },
  // {
  //   id: '2',
  //   name: 'PIM',
  //   description: 'desc',
  //   progress: 100,
  //   soiling_risk_assessment: SoilingRiskAssessment.LOW,
  //   monthly_soiling_rate: 0.5,
  //   cleaning_solution: 'Tractor',
  //   yearly_cleaning_frequency: 1,
  //   location: {
  //     latitude: 30.790278,
  //     longitude: -112.739722
  //   }
  // },
  // {
  //   id: '3',
  //   name: 'RUM',
  //   description: 'desc',
  //   progress: 20,
  //   soiling_risk_assessment: SoilingRiskAssessment.UNDEFINED,
  //   monthly_soiling_rate: null,
  //   cleaning_solution: null,
  //   yearly_cleaning_frequency: null,
  //   location: {
  //     latitude: 32.568333,
  //     longitude: -115.94
  //   }
  // },
];
